


























































































































import TimeInput from "../../core/Forms/TimeInput.vue";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import ContactSelect from "../../core/Forms/ContactSelect.vue";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import OptionSelect from "../../core/Forms/OptionSelect.vue";
import { Contact } from "../../models/Contact";
import InputField from "../../core/Forms/InputField.vue";
import { RecurrenceIntervention } from "../../models/RecurrenceIntervention";
import RecurrenceInterventionFrequenceEdit from "./RecurrenceInterventionFrequenceEdit.vue";
import DateInput from "../../core/Forms/DateInput.vue";
import CheckboxInput from "../../core/Forms/CheckboxInput.vue";

export default {
    name: "RecurrenceInterventionModalEdit",
    components: {
        CheckboxInput,
        DateInput,
        RecurrenceInterventionFrequenceEdit,
        InputField,
        OptionSelect,
        EmployeSelect,
        ContactSelect,
        TextareaInput,
        NumeralInput,
        TimeInput,
    },
    props: {
        recurrenceIntervention: RecurrenceIntervention,
    },
    data() {
        return {
            contactSelectFilters: [
                Contact.EType.Copropriete,
                Contact.EType.Bureau,
                Contact.EType.Particulier,
            ],
        };
    },
    methods: {
        addFrequence() {
            this.recurrenceIntervention.frequences.push(
                new RecurrenceIntervention.Frequence({})
            );
        },
        deleteFrequence(frequence: RecurrenceIntervention.Frequence) {
            let deletedFrequence = _.first(
                _.remove(this.recurrenceIntervention.frequences, {
                    __uniqueid: frequence.__uniqueid,
                })
            );
            this.$forceUpdate();
            this.$emit("delete-frequence", deletedFrequence);
        },
    },
    watch: {
        recurrenceIntervention: {
            handler: function () {
                this.recurrenceIntervention.updateHoraireFin();
            },
            deep: true,
        },
    },
};
